export const apiUrl =
  process.env.API_URL || process.env.NEXT_PUBLIC_API_URL || process.env.REACT_APP_API_URL;
export const appUrl = (() => {
  if (process.env.NEXT_PUBLIC_APP_URL) {
    return process.env.NEXT_PUBLIC_APP_URL?.startsWith('https://') ||
      process.env.NEXT_PUBLIC_APP_URL?.startsWith('http://')
      ? process.env.NEXT_PUBLIC_APP_URL
      : `https://${process.env.NEXT_PUBLIC_APP_URL}`;
  }

  if (process.env.REACT_APP_APP_URL) {
    return process.env.REACT_APP_APP_URL?.startsWith('https://') ||
      process.env.REACT_APP_APP_URL?.startsWith('http://')
      ? process.env.REACT_APP_APP_URL
      : `https://${process.env.REACT_APP_APP_URL}`;
  }

  return;
})();

export const cdnUrl = process.env.NEXT_PUBLIC_CDN_URL || process.env.REACT_APP_CDN_URL;
export const imagesBucketUrl =
  process.env.NEXT_PUBLIC_IMAGES_BUCKET_URL || process.env.REACT_APP_IMAGES_BUCKET_URL;
export const stripePublicKey = process.env.NEXT_PUBLIC_STRIPE_PK || process.env.REACT_APP_STRIPE_PK;
export const stripePublicKeyTest =
  process.env.NEXT_PUBLIC_STRIPE_PK_TEST || process.env.REACT_APP_STRIPE_PK_TEST;
export const recaptchaSiteKey =
  process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
export const rootDomain = process.env.NEXT_PUBLIC_ROOT_DOMAIN || process.env.REACT_APP_ROOT_DOMAIN;
